(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBannerTimer(sectionEl) {
    var timer = sectionEl.querySelector('.campaign-banner__timer');
    if (!timer) return;

    var existingInterval = parseInt(sectionEl.dataset.cbInterval);
    if (existingInterval) clearInterval(existingInterval);

    var endDay = parseInt(timer.dataset.endDay);
    var endMonth = parseInt(timer.dataset.endMonth);
    var endYear = parseInt(timer.dataset.endYear);
    var endHour = parseInt(timer.dataset.endHour || '0');
    var endMinute = parseInt(timer.dataset.endMinute || '0');

    if (!endDay || !endMonth || !endYear) return;

    var end = new Date(endYear, endMonth - 1, endDay, endHour, endMinute, 0);

    var startDay = parseInt(timer.dataset.startDay);
    var startMonth = parseInt(timer.dataset.startMonth);
    var startYear = parseInt(timer.dataset.startYear);
    var startHour = parseInt(timer.dataset.startHour || '0');
    var startMinute = parseInt(timer.dataset.startMinute || '0');
    var start = (startDay && startMonth && startYear)
      ? new Date(startYear, startMonth - 1, startDay, startHour, startMinute, 0)
      : null;

    var isEditor = window.Shopify && window.Shopify.designMode;

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var now = new Date();
      if (start && now < start) {
        if (!isEditor) sectionEl.setAttribute('hidden', '');
        return;
      }
      var diff = end - now;
      if (diff <= 0) {
        if (!isEditor) sectionEl.setAttribute('hidden', '');
        clearInterval(parseInt(sectionEl.dataset.cbInterval));
        return;
      }
      sectionEl.removeAttribute('hidden');
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var seconds = Math.floor((diff % 60000) / 1000);
      var daysEl = timer.querySelector('[data-cb-days]');
      var hoursEl = timer.querySelector('[data-cb-hours]');
      var minsEl = timer.querySelector('[data-cb-minutes]');
      var secsEl = timer.querySelector('[data-cb-seconds]');
      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minsEl) minsEl.textContent = pad(minutes);
      if (secsEl) secsEl.textContent = pad(seconds);
    }

    tick();
    var intervalId = setInterval(tick, 1000);
    sectionEl.dataset.cbInterval = intervalId;
  }

  function initAllBanners(root) {
    root.querySelectorAll('.campaign-banner').forEach(initBannerTimer);
  }

  initAllBanners(document);

  document.addEventListener('shopify:section:load', function (event) {
    initAllBanners(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lds-main-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
